import { z } from "zod"

// Definition of the Season schema
export const seasonSchema = z.object({
  /** Unique Genability ID for each season */
  seasonId: z.number().int(),
  /** The ID of the LSE this territory belongs to */
  lseId: z.number().int(),
  /** The ID of the season group that contains this season */
  seasonGroupId: z.number().int(),
  /** The name of the season */
  seasonName: z.string(),
  /** Value of 1-12 representing the month this season begins */
  seasonFromMonth: z.number().int(),
  /** Value of 1-31 (depending on month)
   * representing the day this season begins */
  seasonFromDay: z.number().int(),
  /** Can be null, PREDOMINANT, or SUBSERVIENT */
  fromEdgePredominance: z
    .enum([`PREDOMINANT`, `SUBSERVIENT`])
    .nullable()
    .optional(),
  /** Value of 1-12 representing the month this season ends */
  seasonToMonth: z.number().int(),
  /** Value of 1-31 (depending on month) representing the day this season ends */
  seasonToDay: z.number().int(),
  /** Can be null, PREDOMINANT, or SUBSERVIENT */
  toEdgePredominance: z
    .enum([`PREDOMINANT`, `SUBSERVIENT`])
    .nullable()
    .optional(),
})

// Definition of the SeasonGroup schema
export const seasonGroupSchema = z.object({
  /** Unique Genability ID for each season group */
  seasonGroupId: z.number().int(),
  /** A List of the Seasons within this Season Group */
  seasons: z.array(seasonSchema),
})

export type Season = z.infer<typeof seasonSchema>
export type SeasonGroup = z.infer<typeof seasonGroupSchema>
